import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import {
  InstaCitiCountries,
  InstacitiJSON0,
  InstacitiJSON1,
  InstacitiJSON2,
  InstacitiJSON3,
  InstacitiJSON4,
  InstacitiJSON5,
  InstacitiJSON6,
  InstacitiMetadata,
  InstaPopularCity,
} from "../instaciti-new.interface";
import { catchError, map } from "rxjs/operators";

@Injectable()
export class InstacitiNewService {
  private endpoint: string = "https://entityserver.manikworks.com/entitymgr";
  private schoolEndpoint: string = "https://entityserver.manikworks.com/school";
  private bizappEndpoint: string = "https://entityserver.manikworks.com/bizapp";
  private urlMetadataEndpoint: string =
    "https://entityserver.manikworks.com/urlmetadata";
  private locationMetaDataEndpoint: string =
    "https://entityserver.manikworks.com/locationmetadata";
  private nearbyBizendpoint: string =
    "https://entityserver.manikworks.com/nearbybiz";
  private filterEndpoint: string =
    "https://entityserver.manikworks.com/filters";
  private keywordEndpoint: string =
    "https://entityserver.manikworks.com/keywords";
  private nearbyEndpoint: string =
    "https://entityserver.manikworks.com/nearbylocalities";
  private countryEndpoint: string =
    "https://entityserver.manikworks.com/apputils";
  private popularCitiesEndpoint: string =
    "https://entityserver.manikworks.com/popularcities";
  private manikJSON: InstacitiMetadata;
  private json0: InstacitiJSON0[];
  private json1: InstacitiJSON1[];
  private json2: InstacitiJSON2[];
  private json3: InstacitiJSON3[];
  private json4: InstacitiJSON4[];
  private json5: InstacitiJSON5[];
  private json6: InstacitiJSON6[];
  private selectedCountry: InstaCitiCountries;
  private selectedCity;
  public selectedCountrySubject: Subject<InstaCitiCountries>;
  public selectedCitySubject: Subject<any>;
  public instaSubject: Subject<boolean>;
  public locationSubject: Subject<string>;
  public citiesSubject: Subject<any>;
  public popularCitiesSubject: Subject<InstaPopularCity[]>;
  constructor(private http: HttpClient) {
    this.instaSubject = new Subject<boolean>();
    this.locationSubject = new Subject<string>();
    this.citiesSubject = new Subject<any>();
    this.popularCitiesSubject = new Subject<InstaPopularCity[]>();
    this.selectedCountrySubject = new Subject<InstaCitiCountries>();
    this.selectedCitySubject = new Subject<any>();
  }

  public getInstacitiGlbalData(): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      LGContext: "MANIK.GLOBAL",
      Context: " PORTAL",
      EntityActionType: " PORTAL.APP.DATA",
      QueryFilter: "100000",
    });
    const options = { headers };
    return this.http.post(this.endpoint, null, options).pipe();
  }

  public setGlobalJsonData(obj: InstacitiMetadata) {
    this.manikJSON = obj;
    this.json0 = obj.JSon0;
    this.json1 = obj.JSon1;
    this.json2 = obj.JSon2;
    this.json3 = obj.JSon3;
    this.json4 = obj.JSon4;
    this.json5 = obj.JSon5;
    this.json6 = obj.JSon6;
  }

  public getGlobalJsonData(): InstacitiMetadata {
    return this.manikJSON;
  }
  public getGlobalJson0(): InstacitiJSON0[] {
    return this.json0;
  }
  getCountryFromIpAddress(): Observable<any> {
    return this.http.get<any>('https://geolocation-db.com/json/')
    .pipe(catchError(() => {
      return this.http.get<any>('https://jsonip.com/').pipe(
        map(response => {
          return {...response, country_code: response.country};
        })
      )
    })
  )
  .pipe(
    map(response => {
      return response;
    })
  )
  }

  public getGlobalJson1(): InstacitiJSON1[] {
    return this.json1;
  }
  public getGlobalJson2(): InstacitiJSON2[] {
    return this.json2;
  }
  public getGlobalJson3(): InstacitiJSON3[] {
    return this.json3;
  }
  public getGlobalJson4(): InstacitiJSON4[] {
    return this.json4;
  }
  public getGlobalJson5(): InstacitiJSON5[] {
    return this.json5;
  }
  public getGlobalJson6(): InstacitiJSON6[] {
    return this.json6;
  }

  public setSelectedCountry(country: InstaCitiCountries) {
    localStorage.setItem("InstaSelectedCountry", JSON.stringify(country));
    this.selectedCountry = country;
  }

  public getSelectedCountry(): InstaCitiCountries {
    return this.selectedCountry;
  }

  public setSelectedCity(city) {
    localStorage.setItem("InstaSelectedCity", JSON.stringify(city));
    this.selectedCity = city;
  }

  public getSelectedCity() {
    return this.selectedCity;
  }

  GetCitiesOfCountry(CountryID: number): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      QueryFilter: sessionStorage.getItem("PortalIdentifier") + "_" + CountryID,
      actioncontext: "SEMI.QUICK",
      context: "PORTAL",
      EntityActionType: "PORTAL.GET.CITIES",
      lgcontext: "MANIK.GLOBAL",
    });
    const options = { headers };
    return this.http.post(this.endpoint, null, options).pipe();
  }

  GetCountries(): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      context: "GET.COUNTRY.AND.LANGUAGE",
    });
    const options = { headers };
    return this.http.post(this.countryEndpoint, null, options).pipe();
  }

  GetPopularCities(obj: InstaCitiCountries): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      CountryID: obj.CountryID.toString(),
      Latitude: obj.Latitude,
      Longitude: obj.Longitude,
    });
    const options = { headers };
    return this.http.get(this.popularCitiesEndpoint, options).pipe();
  }

  GetNearByLocalities(obj: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      CountryID: obj.CountryID.toString(),
      Latitude: obj.Latitude,
      Longitude: obj.Longitude,
      SearchText: obj.SearchText,
      portalds: obj.portalds,
    });
    const options = { headers };
    return this.http.get(this.nearbyEndpoint, options).pipe();
  }
  SearchByKeyword(city: any, searchtext): Observable<any> {
    console.log("cvdfvc",city);
    
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      CountryID: city.CountryID.toString(),
      Latitude: city.Latitude,
      Longitude: city.Longitude,
      SearchText: searchtext,
    });
    const options = { headers };
    return this.http.get(this.keywordEndpoint, options).pipe();
  }
  GetFilterData(city: any, searchtext): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      CountryID: city.CountryID.toString(),
      Latitude: city.Latitude,
      Longitude: city.Longitude,
      SearchText: searchtext,
    });
    const options = { headers };
    return this.http.get(this.filterEndpoint, options).pipe();
  }

  onCountryChange(CountryID: number): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      queryfilter: CountryID.toString(),
      actioncontext: "GET.SUPPORT.INFO",
      context: "MANIK.COUNTRY",
      lgcontext: "MANIK.GLOBAL",
      entityactiontype: "GET.SUPPORT.INFO",
      portalcontext: "INSTACITI",
    });
    const options = { headers };
    return this.http.get(this.endpoint, options).pipe();
  }

  getListings(catId: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      PortalDS: "INSTACITI",
      LGContext: "PSEUDOELASTIC",
      Context: "LIVE.BUSINESS",
      EntityActionType: "TEMP.BIZ",
      QueryFilter: catId,
    });
    const options = { headers };
    return this.http.get(this.endpoint, options).pipe();
  }

  getNearByBiz(body): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
    });
    const options = { headers };
    return this.http.post(this.nearbyBizendpoint, body, options).pipe();
  }
  getLocationMetaData(locn): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      Location: locn,
    });
    const options = { headers };
    return this.http.get(this.locationMetaDataEndpoint, options).pipe();
  }

  getURLMetaData(locn, keyword): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      Location: locn,
      KeywordURL: keyword,
    });
    const options = { headers };
    return this.http.get(this.urlMetadataEndpoint, options).pipe();
  }

  getSchoolInfo(handle): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      Operation: "SCHOOL.DETAILS",
      QueryFilter: handle,
    });
    const options = { headers };
    return this.http.post(this.schoolEndpoint, null, options).pipe();
  }

  getSchoolFormData(handle): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: "Bearer " + sessionStorage.getItem("sToken"),
      LGContext: "SCHOOL",
      Context: "SCHOOL",
      EntityActionType: "GET.FORM.DATA",
      QueryFilter: handle,
    });
    const options = { headers };
    return this.http.post(this.endpoint, null, options).pipe();
  }
}
